export default "assets/images/bg-carte-sols-1ed07f8f.jpg";